import { render, staticRenderFns } from "./SnapshotsView.vue?vue&type=template&id=152f8f21&"
import script from "./SnapshotsView.vue?vue&type=script&lang=js&"
export * from "./SnapshotsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports